import React, { useState } from 'react';
import { cn } from '../lib/cn';

export function PlayerAvatar({ name, imageUrl, size = 'md' }: { name: string; imageUrl: string | null; size?: 'sm' | 'md' | 'lg' }) {
  const [imgFailed, setImgFailed] = useState(false);
  const parts = name.split(' ').filter(Boolean);
  const initials = parts.length >= 2
    ? `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`
    : name.charAt(0);

  const sizeCls = size === 'sm' ? 'w-7 h-7 text-[9px]' : size === 'lg' ? 'w-12 h-12 text-sm' : 'w-9 h-9 text-[11px]';

  if (imageUrl && !imgFailed) {
    return (
      <img
        src={imageUrl} alt={name}
        className={cn('rounded-full object-cover bg-slate-700 shrink-0', sizeCls)}
        onError={() => setImgFailed(true)}
      />
    );
  }
  return (
    <div className={cn('rounded-full bg-slate-700 shrink-0 flex items-center justify-center font-bold text-slate-400', sizeCls)}>
      {initials}
    </div>
  );
}
